import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";
import { initKeycloak, keycloak, logout } from "@/config/Keycloak.ts";
import { Nullable } from "@/type/Common.ts";
import User from "@/model/User.ts";
import { Spinner } from "@/components/ui/spinner.tsx";
import { Role } from "@/enum/RoleEnum.ts";

type KeycloakContextType = {
    initialized: boolean;
    user: Nullable<User>;
    logout: () => void;
};

const KeycloakContext = createContext<KeycloakContextType>({
    initialized: false,
    user: null,
    logout: () => {},
});

type KeycloakProviderProps = PropsWithChildren;

export const KeycloakProvider = ({ children }: KeycloakProviderProps) => {
    const [initialized, setInitialized] = useState(false);
    const [user, setUser] = useState<Nullable<User>>(null);

    useEffect(() => {
        initKeycloak()
            .then(async auth => {
                if (keycloak.tokenParsed) {
                    const roles = keycloak.resourceAccess?.inspection?.roles;
                    const phoneNumber = keycloak.tokenParsed.phone;
                    const phone = phoneNumber ? phoneNumber.replace(/^\+82-/, "") : null;
                    setUser(new User(keycloak.tokenParsed.email, keycloak.tokenParsed.name, phone, (roles as Role[]) || [Role.CREW]));
                }
                setInitialized(auth);
            })
            .catch(err => console.error("Failed to initialize Keycloak", err));
    }, []);

    if (!initialized) {
        return (
            <div className="w-full h-screen justify-center content-center">
                <Spinner />
            </div>
        );
    }

    return <KeycloakContext.Provider value={{ initialized, user, logout }}>{children}</KeycloakContext.Provider>;
};

export const useKeycloak = () => useContext(KeycloakContext);